<!-- Change Fleet Modal -->
<div class="modal fade" id="changeFleetModal" tabindex="-1" aria-labelledby="changeFleetModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="changeFleetModalLabel">Change Fleet</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div *ngIf="selectedLocation">
          <p>Change fleet for location: <strong>{{ selectedLocation.label }}</strong></p>

          <div class="mb-3">
            <label for="fleetSelect" class="form-label">Select New Fleet</label>
            <div class="dropdown w-100">
              <button class="btn btn-outline-secondary dropdown-toggle w-100 d-flex justify-content-between align-items-center"
                      type="button"
                      id="changeFleetDropdown"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      [disabled]="loading || flattenedFleets.length === 0">
                <span>{{ selectedFleet?.id || 'Select a fleet' }}</span>
                <div *ngIf="loading" class="spinner-border spinner-border-sm ms-2" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </button>
              <ul class="dropdown-menu w-100" aria-labelledby="fleetDropdown">
                <li *ngFor="let fleet of flattenedFleets">
                  <a class="dropdown-item cursor-pointer" (click)="selectFleet(fleet)" id="change_fleet_to_{{ fleet.id }}">
                    <span *ngIf="fleet.level > 0" [style.margin-left.px]="fleet.level * 12">&nbsp;</span>
                    {{ fleet.id }}
                  </a>
                </li>
                <li *ngIf="flattenedFleets.length === 0 && !loading">
                  <span class="dropdown-item text-muted">No fleets available</span>
                </li>
              </ul>
            </div>
          </div>

          <div *ngIf="error" class="alert alert-danger mt-2">{{ error }}</div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeModal()">Cancel</button>
        <button type="button" class="btn btn-primary" [disabled]="!selectedFleet" (click)="changeFleet()">Change</button>
      </div>
    </div>
  </div>
</div>
